"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSocket = exports.configureSocket = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _pusherJs = _interopRequireDefault(require("pusher-js"));

var _env = _interopRequireDefault(require("./env"));

var _events = require("./events");

var _logger = _interopRequireDefault(require("./logger"));

var _meta = require("./meta");

var _providers = require("./providers");

var _state = require("./state");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * Wrap the disconnect method in our implementation. We want to wipe
 * the socketInstance on disconnect so any subsequent calls to `getSocket()`
 * will create a new connection.
 *
 * @param {object} socket Socket instance.
 */
var clearInstanceOnDisconnect = function clearInstanceOnDisconnect(socket) {
  var disconnect = socket.disconnect.bind(socket);

  socket.disconnect = function () {
    (0, _state.setState)({
      socket: null
    });
    return disconnect();
  };
};
/**
 * @param {string} provider WebSocket provider.
 *
 * @returns {object} Socket instance.
 */


var createSocketInstance = function createSocketInstance(provider) {
  var _getState = (0, _state.getState)(),
      environment = _getState.environment;

  var connectId = (0, _meta.getConnectId)(provider);
  var socket;

  if (provider === _providers.WS_PUSHER) {
    socket = new _pusherJs.default(connectId, {
      authEndpoint: environment.socketIoUrl,
      // eslint-disable-line no-undef
      cluster: environment.pusherAppCluster,
      disableStats: true,
      encrypted: true,
      forceTLS: true // authorizer: ({ name }) => {
      //   return {
      //     authorize: (socketId, callback) => {
      //       console.log('hello');
      //       const { authToken, environment } = getState();
      //       console.log(authToken, 'world');
      //       if (authToken === null) {
      //         callback(true, null);
      //         return;
      //       }
      //       fetch(environment.socketIoUrl, {
      //         headers: {
      //           Authorization: `Bearer ${authToken}`,
      //           'Content-Type': 'application/x-www-form-url-encoded'
      //         },
      //         method: 'POST',
      //         body: encodeFormData({ socketId, channel: name})
      //         // JSON.stringify({
      //         //   socketId,
      //         //   channel: name
      //         // })
      //       })
      //       .then(res => res.json())
      //       .then(res => {
      //         if (res.accessToken) {
      //           callback(false, { auth: res.data.auth });
      //         }
      //         else {
      //           callback(true, null)
      //         }
      //       })
      //     }
      //   }
      // }

    });
  } else if (provider === _providers.WS_SOCKET_IO) {
    socket = io(connectId); // eslint-disable-line no-undef
  }

  return socket;
};
/**
 * Sets the socket configuration object. Should be run on application start.
 *
 * @param {string} env Socket environment type (development, stage, production)
 * @param {boolean} mock Should we mock the socket?
 * @param {boolean} logger Should we log network requests?
 * @param {integer} connectionDelay If we mock socket, delays broadcasting
 *   the `onConnect()` method.
 */


var configureSocket =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(env, mock, logger, connectionDelay) {
    var environment;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            environment = (0, _env.default)(env);
            _context.next = 3;
            return (0, _state.setState)({
              connectionDelay: connectionDelay,
              environment: environment,
              logger: logger,
              mock: mock
            });

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function configureSocket(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}(); // TODO If connectionDelay < 0, the connection should fail.


exports.configureSocket = configureSocket;

var createSocket =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee2() {
    var provider,
        _getState2,
        connectionDelay,
        logger,
        mock,
        socket,
        _ref3,
        mockSocket,
        _args2 = arguments;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            provider = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : _providers.WS_PROVIDER;
            _getState2 = (0, _state.getState)(), connectionDelay = _getState2.connectionDelay, logger = _getState2.logger, mock = _getState2.mock;

            if (mock) {
              _context2.next = 7;
              break;
            }

            socket = createSocketInstance(provider); // We want to use the same interface regardless of the selected provider.

            if (provider === _providers.WS_PUSHER) {
              socket.connection.bind('error', function (err) {
                if (err.error.data.code === 4004) {
                  throw new Error('Pusher exceeded its limits!');
                }
              });

              socket.on = function (event, callback) {
                if (event === _events.WS_CONNECT) {
                  return socket.connection.bind('connected', function () {
                    // Subscribe to channel.
                    var socketId = (0, _meta.getSocketId)(socket);
                    socket.subscribe(socketId);
                    return callback();
                  });
                }

                if (event === _events.WS_DISCONNECT) {
                  var onDisconnect = function onDisconnect(data) {
                    return callback(_events.WS_DISCONNECT, data);
                  };

                  socket.connection.bind('disconnected', onDisconnect);
                  socket.connection.bind('unavailable', onDisconnect);
                  return undefined;
                }

                return socket.bind(event, callback);
              };

              socket.removeListener = socket.unbind;
            }

            _context2.next = 12;
            break;

          case 7:
            _context2.next = 9;
            return new Promise(function (resolve) {
              require.ensure([], function (require) {
                resolve(require('./mock'));
              });
            });

          case 9:
            _ref3 = _context2.sent;
            mockSocket = _ref3.mockSocket;
            socket = mockSocket(provider, (0, _meta.getConnectId)(provider), connectionDelay);

          case 12:
            if (logger) {
              (0, _logger.default)(socket);
            }

            clearInstanceOnDisconnect(socket);
            return _context2.abrupt("return", socket);

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function createSocket() {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Returns a real or emulated WebSocket instance.
 */


var getSocket =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee3(provider) {
    var _getState3, socket;

    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _getState3 = (0, _state.getState)(), socket = _getState3.socket;

            if (socket) {
              _context3.next = 7;
              break;
            }

            _context3.next = 4;
            return createSocket(provider);

          case 4:
            socket = _context3.sent;
            _context3.next = 7;
            return (0, _state.setState)({
              socket: socket
            });

          case 7:
            return _context3.abrupt("return", socket);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function getSocket(_x5) {
    return _ref4.apply(this, arguments);
  };
}();

exports.getSocket = getSocket;